/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kxv-Orya",[["ଏ","ପି"],["ଏ ଏମ","ପି ଏମ"],["ଏ ଏମ","ପି ଏମ"]],[["ଏ ଏମ","ପି ଏମ"],u,["ଏ ଏମ","ପି ଏମ"]],[["ଆ","ସ","ମା","ପୁ","ଲା","ସୁ","ସା"],["ଆଦି","ସମ୍ବା","ମାଙ୍ଗା","ପୁଦା","ଲାକି","ସୁକ୍ରୁ","ସାନି"],["ଆଦି ୱାରା","ସମ୍ବାରା","ମାଙ୍ଗାଡ଼ା","ପୁଦାରା","ଲାକି ୱାରା","ସୁକ୍ରୁ ୱାରା","ସାନି ୱାରା"],["ଆ","ସ","ମା","ପୁ","ଲା","ସୁ","ସାନି"]],u,[["ପୁ","ମା","ପା","ହି","ବେ","ଜା","ଆ","ସ୍ରା","ବ","ଦା","ଦି","ପା"],["ପୁସୁ","ମାହା","ପାଗୁ","ହିରେ","ବେସେ","ଜାଟା","ଆସାଡ଼ି","ସ୍ରାବାଁ","ବଦ","ଦାସାରା","ଦିୱି","ପାଣ୍ଡେ"],["ପୁସୁ ଲେଞ୍ଜୁ","ମାହାକା ଲେଞ୍ଜୁ","ପାଗୁଣି ଲେଞ୍ଜୁ","ହିରେ ଲେଞ୍ଜୁ","ବେସେ ଲେଞ୍ଜୁ","ଜାଟା ଲେଞ୍ଜୁ","ଆସାଡ଼ି ଲେଞ୍ଜୁ","ସ୍ରାବାଁ ଲେଞ୍ଜୁ","ବଦ ଲେଞ୍ଜୁ","ଦାସାରା ଲେଞ୍ଜୁ","ଦିୱିଡ଼ି ଲେଞ୍ଜୁ","ପାଣ୍ଡେ ଲେଞ୍ଜୁ"]],u,[["ବିସି","ଏଡି"],u,["ବିଫୋର କ୍ରାଇଷ୍ଟ","ଆନ୍ନା ଡୋମିନି"]],0,[0,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,"{1} ଆଁ {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##0%","¤#,##,##0.00","#E0"],"INR","₹","ବାରତ ତି ଟାକାଁ",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
